export default "__VITE_ASSET__b8d98b5f__"